import type { Cliente } from '../../types';
import CrmRecordForm from '../crm/CrmRecordForm';

export default function ClientEditForm({ client, onUpdate, onCancel }: { client: Cliente; onUpdate: () => void; onCancel?: () => void }) {
  return <CrmRecordForm kind="client" client={client} onSaved={onUpdate} onCancel={onCancel || onUpdate} />;
}
